import con from '../../../../connection';
var path = '/merger';
export var merger = function (url) { return function () { return ({
    post: function (param) {
        return con.post(url + path, param);
    },
}); }; };
